// import $ from 'jquery';
import BaseAction from './base.js';
import cartDrawerInit from './instance-builders/cart-drawer.js';
import cartModalInit from './instance-builders/cart-modal.js';
import cartDropdownInit from './instance-builders/cart-dropdown.js';
import { getOptionsFromDataset } from '../../../util/dom.js';

export default class CartAction extends BaseAction {

	/**
	 * @param {JQuery} $container
	 */
	async init($container) {

		const $cartButtons = $container.find('[data-toggle-cart]');

		for (const cartButton of $cartButtons) {

			// Get dataset options
			const options = getOptionsFromDataset(cartButton, 'toggleCart', true);

			switch (options.display) {

				// Load cart preview in dropdown
				case 'dropdown': {

					// Get the tippy container
					const $menuContainer = $container.find('[data-menu-container]').length > 0 ? $container.find('[data-menu-container]') : $container.find('#header');
					cartDropdownInit($menuContainer, cartButton, options);

					break;
				}

				// Load cart preview in modal
				case 'modal': {

					// Init triggers that open the cart modal (no tippy instance)
					cartModalInit(cartButton, options);
					break;
				}

				// Redirect to cart page
				case 'page': {

					$(cartButton).on('click.show-cart-page', (_) => {
						mpro.setLocation(mpro.config.routes.cart);
					});

					break;
				}

				// Default to 'drawer'
				default: {

					// Init triggers that open the cart drawer (no tippy instance)
					cartDrawerInit(cartButton, options);
				}
			}
		}
	}
}
